// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".label--add[data-v-1e5ee50a] {\n  margin-bottom: var(--space-micro);\n  margin-right: var(--space-micro);\n}", "",{"version":3,"sources":["/app/app/javascript/shared/components/ui/dropdown/AddLabel.vue"],"names":[],"mappings":"AAuBA;EACE,iCAAA;EACA,gCAAA;AAtBF","file":"AddLabel.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.label--add {\n  margin-bottom: var(--space-micro);\n  margin-right: var(--space-micro);\n}\n"]}]);
// Exports
module.exports = exports;
